import { QueryClient } from '@tanstack/react-query';
import {
  appointmentsQueryKey,
  billingWorkspaceQueryKey,
  carePlansQueryKey,
  fetchAppointments,
  fetchBillingWorkspace,
  fetchCarePlans,
  fetchOpsSummary,
  fetchPatients,
  opsSummaryQueryKey,
  patientsQueryKey,
  PrefetchBundle,
  QueryEnvelope,
} from '@/services/api';

export const prefetchCoreQueries = (client: QueryClient) =>
  Promise.all([
    client.prefetchQuery({ queryKey: patientsQueryKey, queryFn: fetchPatients }),
    client.prefetchQuery({ queryKey: appointmentsQueryKey, queryFn: fetchAppointments }),
    client.prefetchQuery({ queryKey: carePlansQueryKey, queryFn: fetchCarePlans }),
    client.prefetchQuery({ queryKey: billingWorkspaceQueryKey, queryFn: fetchBillingWorkspace }),
    client.prefetchQuery({ queryKey: opsSummaryQueryKey, queryFn: fetchOpsSummary }),
  ]);

export const hydratePrefetchBundle = (client: QueryClient, bundle: PrefetchBundle) => {
  const setData = <T>(key: readonly unknown[], value: T) => {
    client.setQueryData<QueryEnvelope<T>>(key, { value, fallback: false });
  };

  setData(patientsQueryKey, bundle.patients);
  setData(appointmentsQueryKey, bundle.appointments);
  setData(carePlansQueryKey, bundle.carePlans);
  setData(billingWorkspaceQueryKey, bundle.billing);
  setData(opsSummaryQueryKey, bundle.ops);
};
